<script>
    /*
    	VerticalResourceMenuButton.svelte
    */

    import { onMount } from 'svelte';

    // TCARE components

    // SMUI components

    export let node;
    export let button;
    export let onClick;

    onMount(() => {
        // console.log('VerticalResourceMenuButton onMount');
        // console.log(button);
    })

</script>

<style>

    .resource-menu-button {
        width: 155px;
        margin-bottom: 5px;
        padding: 5px 15px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-size: 15px;
        font-weight: 500;
        color: var(--tcui-primary);
        background-color: var(--tcui-white);
        border-radius: 12px;
        border: none;
        outline: none;
    }

    .resource-menu-button:hover {
        background-color: #D3DDF9;
    }

    .resource-menu-button.selected {
        background-color: #DFCDD8;
    }

    .resource-menu-button .icon {
        width: 20px;
        height: 20px;
        margin-right: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        /* border: 1px solid red; */
    }

    .resource-menu-button img {
        width: 100%;
        height: 100%;
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<!-- should find an easier way to show selected style that will not block hover -->

{#if button.isSelected}
    <button class="resource-menu-button selected" on:click={() => onClick(node, button)}  >
            <div class="icon">
                <img src={button.iconPath} alt={button.keyword} draggable={false} />
            </div>
            {node.label}
    </button>
{:else}
    <button class="resource-menu-button" on:click={() => onClick(node, button)}  >
            <div class="icon">
                <img src={button.iconPath} alt={button.keyword} draggable={false} />
            </div>
            {node.label}
    </button>
{/if}
